<template>
	<div class="row">
		<div class="form-row">
			<div class="col-sm-6 col-xl-4 my-2">
				<label>{{ __("From") }}</label>
				<crop-month-picker-component
					:obj="months"
					field="month_from"
					v-bind:disable-past-months="false"
					:key="'Months_from-' + months.length"
				/>
			</div>
			<div class="col-sm-6 col-xl-4 my-2">
				<label>{{ __("Until") }}</label>
				<crop-month-picker-component
					:obj="months"
					field="month_to"
					v-bind:disable-past-months="false"
					:key="'Months_to-' + months.length"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		months: {
			type: Object,
			required: true,
		},
	},
};
</script>
